import React, { useRef, useState, useEffect } from "react"
import { Container, Row, Col, Table, Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import "./paymentInfo.css"
import { useParams } from "react-router-dom"
import { NoData } from "../no-data/NoData"
import enrolAPI from "../../apis/enrollAPI"
import {
  addNoteFromEnrolment,
  updateEnrolmentAction,
} from "../../pages/enrolment/enrolmentAction"
import { compareAsc } from "date-fns"
import { toast } from "react-toastify"

const PaymentInfo = () => {
  const { _id } = useParams()
  const { user } = useSelector((state) => state.user)
  const dispatch = useDispatch()
  const amountRef = useRef()
  const dateRef = useRef()
  const paidDateRef = useRef()
  const transactionRef = useRef()
  const paymentMethodRef = useRef()
  const sendEmailRef = useRef()
  const discountLabel = useRef()
  const [error, setError] = useState(false)
  const [selectedIns, setSelectedIns] = useState([])
  const [show, setShow] = useState(false)
  const [showUpdateForm, setShowUpdateForm] = useState(false)
  const [showDiscountForm, setShowDiscountForm] = useState(false)
  const [onShowData, setOnShowData] = useState({})
  const [disc, setDisc] = useState(true)
  const { enrollments } = useSelector((state) => state.enroll)
  const enrolment = enrollments.find((enrollment) => enrollment._id === _id)

  const params = new URLSearchParams()
  params.set("branch", user?.branch)
  const par = params.toString()

  useEffect(() => {
    setSelectedIns(enrolment?.payment?.installment)
  }, [enrolment])
  if (!enrolment?.payment) {
    return <NoData />
  }

  const totalAmountPaid = selectedIns?.reduce((total, item) => {
    return total + (item.status === "paid" && item.amount)
  }, 0)
  const totalDiscountApplied = enrolment.discount?.reduce(
    (a, c) => a + c.amount,
    0
  )
  const totalFee = enrolment.fees?.originalFee - totalDiscountApplied
  const remainingFee = totalFee - totalAmountPaid
  const totalInstallmentsCreated = selectedIns?.reduce((total, item) => {
    return total + item.amount
  }, 0)

  const createInstallment = async (e) => {
    e.preventDefault()
    const fName = enrolment.fName
    const email = enrolment.email
    const amount = amountRef.current?.value
    const dueDate = dateRef.current?.value
    const paidDate = paidDateRef.current?.value
    const transactionId = transactionRef.current?.value
    const paymentMethod = paymentMethodRef.current?.value
    const sendEmail = sendEmailRef.current?.checked

    if (!amount || !dueDate) {
      return alert("Please enter the amount and due date")
    } else if (amount > totalFee - totalInstallmentsCreated) {
      setError(true)
    } else if (window.confirm("Are you sure you want to add an installment?")) {
      const newInstallment = {
        _id,
        fName,
        email,
        amount,
        dueDate,
        paidDate,
        transactionId,
        paymentMethod,
        course: enrolment?.course?.name,
        sendEmail,
      }
      const { result } = await enrolAPI.addInstallment(newInstallment)
      e.target.reset()

      const ins = result?.payment?.installment
      setSelectedIns(ins)

      if (result) {
        dispatch(
          updateEnrolmentAction(_id, {
            ...enrolment,
            params: par,
            payment: {
              status: "due soon",
              dueDate,
              installment: [...ins],
            },
          })
        )
      }

      // if (totalAmountPaid === totalFee) {
      //   dispatch(
      //     updateEnrolmentAction(_id, {
      //       ...enrolment,
      //       payment: {
      //         paidFull: true,
      //         status: "paid",
      //         totalPaid: totalAmountPaid,
      //         installment: [...ins],
      //       },
      //     })
      //   ) &&
      //     window.setTimeout(() => {
      //       window.location.reload()
      //     }, 1000)
      // }
    }
    setShow(false)
  }

  const delInstallment = async (installmentId) => {
    if (!installmentId) {
      return
    }
    if (window.confirm("Are you sure you want to delete this installment?")) {
      const obj = { _id, installmentId }

      const { result } = await enrolAPI.deleteInstallment(obj)
      const ins = result?.payment?.installment
      setSelectedIns(ins)

      const total = ins?.reduce((total, ins) => total + ins.amount, 0)

      if (total < totalFee) {
        dispatch(
          updateEnrolmentAction(_id, {
            ...enrolment,
            params: par,
            payment: {
              paidFull: false,
              status: "pending",
              totalPaid: total,
              installment: [...ins],
            },
          })
        )
        // window.setTimeout(() => {
        //   window.location.reload()
        // }, 1000)
      }
    }
  }

  const showModal = (amount, dueDate, installmentId) => {
    const data = {
      amount,
      dueDate,
      installmentId,
    }
    setShowUpdateForm(true)
    setOnShowData(data)
  }

  const updateInstallment = async (e) => {
    e.preventDefault()
    const fName = enrolment.fName
    const email = enrolment.email
    const paidDate = paidDateRef.current?.value
    const transactionId = transactionRef.current?.value
    const paymentMethod = paymentMethodRef.current?.value
    const sendEmail = sendEmailRef.current?.checked
    const insId = onShowData.installmentId
    const amount = amountRef.current?.value

    if (!paidDate || !transactionId || !paymentMethod) {
      return alert("Please fill all the fields")
    } else if (
      window.confirm("Are you sure you want to update this installment?")
    ) {
      const obj = {
        _id,
        insId,
        fName,
        email,
        amount,
        paidDate,
        transactionId,
        paymentMethod,
        sendEmail,
        course: enrolment?.course?.name,
      }
      const { result } = await enrolAPI.updateInstallment(obj)
      setShowUpdateForm(false)

      const ins = result?.payment?.installment
      setSelectedIns(ins)

      if (result) {
        dispatch(
          updateEnrolmentAction(_id, {
            ...enrolment,
            params: par,
            payment: {
              status: "",
              dueDate: "",
              installment: [...ins],
            },
          })
        )
      }
    }
    e.target.reset()

    if (sendEmail) {
      dispatch(
        addNoteFromEnrolment({
          _id,
          message: `Installment paid notification sent! Amount: $${amount}`,
        })
      )
    }
  }

  const addDiscount = async (e) => {
    e.preventDefault()
    const discountAmount = amountRef.current?.value
    const discLabel = discountLabel.current?.value

    if (!discountAmount || !discountLabel) {
      return alert("Please enter the discount amount.")
    } else if (
      window.confirm("Are you sure you want to add discount amount?")
    ) {
      dispatch(
        updateEnrolmentAction(_id, {
          ...enrolment,
          params: par,
          discount: {
            label: discLabel,
            amount: discountAmount,
            disc,
          },
          ...enrolment.discount,
        })
      )
    }
  }

  const sendReminderEmail = async (amount, dueDate) => {
    dispatch(
      addNoteFromEnrolment({
        _id,
        message: `Fee payment reminder sent!`,
        fName: enrolment.fName,
        email: enrolment.email,
        amount,
        dueDate,
        course: enrolment.course?.name,
        params,
      })
    )
  }

  // if (remainingFee === 0) {
  //   dispatch(
  //     updateEnrolmentAction(_id, {
  //       ...enrolment,
  //       payment: {
  //         paidFull: true,
  //         status: "paid",
  //         totalPaid: totalAmountPaid,
  //         installment: [...enrolment.payment?.installment],
  //       },
  //     })
  //   )
  // }

  return (
    <>
      {error &&
        toast.error(
          "Amount entered will result in total payment to be more than " +
            remainingFee
        ) &&
        setError(false)}

      <Modal
        show={showUpdateForm}
        backdrop="static"
        animation={false}
        data={onShowData}
        onHide={() => setShowUpdateForm(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Installment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <form onSubmit={updateInstallment} className="paymentInfoForm">
              <Row>
                <Col>
                  <div className="add-installment">
                    <div className="d-flex flex-column gap-1">
                      <label htmlFor="">
                        <b>Amount</b>
                      </label>
                      <input
                        type="number"
                        defaultValue={onShowData?.amount}
                        className="form-control"
                        ref={amountRef}
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <label htmlFor="">
                        <b>Due Date</b>
                      </label>
                      <input
                        defaultValue={new Date(
                          onShowData.dueDate
                        ).toLocaleDateString()}
                        className="form-control"
                        readOnly
                      />
                    </div>

                    <div className="d-flex flex-column">
                      <label htmlFor="">
                        <b>Transaction ID</b>
                      </label>
                      <input
                        type="text"
                        ref={transactionRef}
                        placeholder="Enter Transaction ID"
                        className="form-control"
                        required
                      />
                    </div>

                    <div className="d-flex flex-column">
                      <label htmlFor="">
                        <b>Paid Date</b>
                      </label>
                      <input
                        type="date"
                        ref={paidDateRef}
                        className="form-control"
                        required
                      />
                    </div>

                    <div className="d-flex flex-column">
                      <label htmlFor="">
                        <b>Payment method</b>
                      </label>
                      <select
                        ref={paymentMethodRef}
                        className="form-control"
                        required
                      >
                        <option value="">
                          ----- Select Payment Method -----
                        </option>
                        <option value="transfer">transfer</option>
                        <option value="card">card</option>
                        <option value="cash">cash</option>
                      </select>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <div className="d-flex gap-2 align-items-center">
                    <label htmlFor="email-checkbox">Send Email</label>
                    <input
                      type="checkbox"
                      ref={sendEmailRef}
                      name="sendEmail"
                    />
                  </div>
                </Col>
              </Row>

              <button type="submit" className="btn btn-success updateBtn">
                Update Installment
              </button>
            </form>
          </>
        </Modal.Body>
      </Modal>

      <Container className="mt-5 courseInfo ">
        <Row className="mt-3">
          <Col>
            <h4 className="enrolInfo d-flex justify-content-between text-primary">
              <span>Payment Info</span>

              <div className="d-flex gap-2 add-pmt-btn">
                <button
                  className={
                    showDiscountForm ? "btn btn-danger" : "btn btn-secondary"
                  }
                  onClick={() => setShowDiscountForm(!showDiscountForm)}
                  disabled={show}
                >
                  {showDiscountForm ? (
                    <div className="d-flex align-items-center gap-1">
                      <i className="fa-solid fa-minus"></i>
                      <span>Cancel</span>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center gap-1">
                      <i className="fas fa-plus"></i>
                      <span>Add discount</span>
                    </div>
                  )}
                </button>
                <button
                  className={
                    show ? "btn btn-danger" : "btn btn-success add-pmt-btn"
                  }
                  onClick={() => setShow(!show)}
                  disabled={showDiscountForm}
                >
                  {show ? (
                    <div className="d-flex align-items-center gap-1">
                      <i className="fa-solid fa-minus"></i>
                      <span>Cancel</span>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center gap-1">
                      <i className="fas fa-plus"></i>
                      <span>Add due Payment</span>
                    </div>
                  )}
                </button>
              </div>
            </h4>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <>
              {show ? (
                <>
                  <h5>Add Installment</h5>
                  <form
                    onSubmit={createInstallment}
                    className="paymentInfoForm"
                  >
                    <Row>
                      <Col>
                        <div className="add-installment">
                          <div className="d-flex flex-column gap-1">
                            <label htmlFor="">
                              <b>Amount</b>
                            </label>
                            <input
                              type="number"
                              ref={amountRef}
                              placeholder="Enter Amount"
                              className="form-control"
                            />
                          </div>
                          <div className="d-flex flex-column">
                            <label htmlFor="">
                              <b>Due Date</b>
                            </label>
                            <input
                              type="date"
                              ref={dateRef}
                              className="form-control"
                            />
                          </div>

                          <div className="d-flex flex-column">
                            <label htmlFor="">
                              <b>Transaction ID</b>
                            </label>
                            <input
                              type="text"
                              ref={transactionRef}
                              placeholder="Enter Transaction ID"
                              className="form-control"
                            />
                          </div>

                          <div className="d-flex flex-column">
                            <label htmlFor="">
                              <b>Paid Date</b>
                            </label>
                            <input
                              type="date"
                              ref={paidDateRef}
                              className="form-control"
                            />
                          </div>

                          <div className="d-flex flex-column">
                            <label htmlFor="">
                              <b>Payment method</b>
                            </label>
                            <select
                              ref={paymentMethodRef}
                              className="form-control"
                            >
                              <option value="">
                                ----- Select Payment Method -----
                              </option>
                              <option value="transfer">transfer</option>
                              <option value="card">card</option>
                              <option value="cash">cash</option>
                            </select>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="d-flex gap-2 align-items-center">
                          <label htmlFor="email-checkbox">Send Email</label>
                          <input
                            type="checkbox"
                            ref={sendEmailRef}
                            name="sendEmail"
                          />
                        </div>
                      </Col>
                    </Row>

                    <button type="submit" className="btn btn-success addBtn">
                      <i className="fa-solid fa-plus"></i> Add Installment
                    </button>
                  </form>
                </>
              ) : showDiscountForm ? (
                <>
                  <h5>Add Discount</h5>
                  <form className="discountForm" onSubmit={addDiscount}>
                    <Row>
                      <Col>
                        <div className="add-discount">
                          <div className="d-flex flex-column gap-1">
                            <label>
                              <b>Label</b>
                            </label>
                            <input
                              type="text"
                              ref={discountLabel}
                              placeholder="Enter Label"
                              className="form-control mb-2"
                            />
                          </div>
                          <div className="d-flex flex-column gap-1">
                            <label>
                              <b>Amount</b>
                            </label>
                            <input
                              type="number"
                              ref={amountRef}
                              placeholder="Enter Amount"
                              className="form-control mb-2"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <button type="submit" className="btn btn-secondary addBtn">
                      <i className="fa-solid fa-plus"></i> Add Discount
                    </button>
                  </form>
                </>
              ) : (
                <>
                  <div className="mb-3">
                    <div className="d-flex flex-column">
                      <h5>
                        Total Discount Applied:{" "}
                        <span className="text-danger">
                          ${totalDiscountApplied ? totalDiscountApplied : 0}
                        </span>{" "}
                      </h5>
                      <h5>Total Fee after discount: ${totalFee}</h5>
                      <h5>
                        Total Fee Paid:{" "}
                        <span className="text-success">
                          $
                          {totalAmountPaid !== 0
                            ? totalAmountPaid
                            : enrolment.payment?.totalPaid}
                        </span>
                      </h5>
                      <h5>
                        Total Remaining Fee:{" "}
                        <span className="text-danger">${remainingFee}</span>
                      </h5>
                      <h5>
                        Payment Status:{" "}
                        <span
                          className={
                            enrolment?.payment?.status === "paid"
                              ? "text-success"
                              : "text-warning"
                          }
                        >
                          {enrolment.payment?.status !== "" ? (
                            enrolment.payment?.status.toUpperCase()
                          ) : totalAmountPaid === totalFee ? (
                            <span className="text-success">PAID</span>
                          ) : (
                            "Pending".toUpperCase()
                          )}
                        </span>
                      </h5>
                    </div>
                  </div>
                </>
              )}

              <hr />
            </>

            <h4>Payment history</h4>

            <Table striped bordered hover className="text-center">
              <thead>
                <tr>
                  <th>Due Date</th>
                  <th>Amount</th>
                  <th>Paid Date</th>
                  <th>Status</th>
                  <th>Method</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedIns?.length > 0 ? (
                  selectedIns.map((paid, i) => (
                    <tr key={i}>
                      <td>{new Date(paid.dueDate).toLocaleDateString()}</td>
                      <td
                        className={
                          paid.status === "pending" ? "text-danger" : ""
                        }
                      >
                        ${paid.amount ? paid.amount : 0}
                      </td>
                      <td>
                        {paid.paidDate
                          ? new Date(paid.paidDate).toLocaleDateString()
                          : "---"}
                      </td>
                      <td
                        className={`${
                          (paid.status === "paid" && "text-success") ||
                          (compareAsc(new Date(), new Date(paid.dueDate)) === -1
                            ? "text-warning"
                            : "text-danger")
                        } 
                        `}
                      >
                        {paid.status !== "paid" &&
                        compareAsc(new Date(), new Date(paid.dueDate)) === 1
                          ? "overdue".toUpperCase()
                          : paid.status.toUpperCase()}
                      </td>
                      <td>{paid.method ? paid.method : "---"}</td>
                      <td className="d-flex gap-3 justify-content-center actions">
                        <button
                          className="btn btn-warning"
                          onClick={() =>
                            sendReminderEmail(paid.amount, paid.dueDate)
                          }
                          disabled={paid.status === "paid"}
                        >
                          Send Reminder
                        </button>
                        <button
                          className="btn btn-info"
                          onClick={() =>
                            showModal(paid.amount, paid.dueDate, paid._id)
                          }
                          disabled={paid.status === "paid"}
                        >
                          Update
                        </button>
                        {user?.role === "admin" && (
                          <button
                            className="btn btn-danger"
                            onClick={() => delInstallment(paid._id)}
                          >
                            Delete
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <tr>
                      <td>
                        {enrolment?.payment?.dueDate
                          ? new Date(
                              enrolment?.payment?.dueDate
                            ).toLocaleDateString()
                          : "---"}
                      </td>
                      <td>${enrolment?.payment?.totalPaid}</td>
                      <td>
                        {new Date(
                          enrolment?.payment?.paidDate
                        ).toLocaleDateString()}
                      </td>
                      <td
                        className={
                          enrolment?.payment?.status === "paid"
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {enrolment?.payment?.status.toUpperCase()}
                      </td>
                      <td>{enrolment?.payment?.method.toUpperCase()}</td>
                    </tr>
                  </>
                )}
                {enrolment?.status === false ? (
                  <tr></tr>
                ) : (
                  <tr>
                    <td>
                      <strong className="fs-5">TOTAL PAID</strong>
                    </td>
                    <td className="text-success fs-5">${totalAmountPaid}</td>
                    <td>---</td>
                    <td
                      className={
                        enrolment?.payment?.status === "paid"
                          ? "text-success"
                          : "text-info"
                      }
                    >
                      {enrolment?.payment?.status === "paid"
                        ? enrolment?.payment?.status.toUpperCase()
                        : "---"}
                    </td>
                    <td>---</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default PaymentInfo
